/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Metadata_Read_OnlyInputs */



/**
* | output |
* | --- |
* | "Read only" |
*
* @param {Iconik_Metadata_Read_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_metadata_read_only = /** @type {((inputs?: Iconik_Metadata_Read_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Metadata_Read_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Read only")
	if (locale === "de") return /** @type {LocalizedString} */ ("Read only")
	if (locale === "it") return /** @type {LocalizedString} */ ("Read only")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Read only")
	if (locale === "es") return /** @type {LocalizedString} */ ("Read only")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Read only")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Read only")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Read only")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Read only")
	return /** @type {LocalizedString} */ ("Read only")
});